/* SG cart drawer (snippets/sg-cart-drawer.liquid). No dependencies.
   - Opens from [data-sg-cart-open] (header cart chip; its href /cart is the
     no-JS fallback) and after any add to cart.
   - Quantity steppers, typed quantities and Remove call /cart/change.js with
     `sections=sg-cart-drawer`, so the response carries freshly rendered
     drawer markup (Shopify's own money, variant and discount output).
   - Hooks the legacy theme's add-to-cart (Shopify.cartPopap / onCartUpdate in
     assets/cart.api.js) so product and collection buttons open the drawer
     instead of the old popup.
   Exposes window.SGCart = { open, close, refresh }. */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-sg-cart-drawer]');
  if (!drawer) return;

  var SECTION = 'sg-cart-drawer';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var panel = drawer.querySelector('.sg-cd__panel');
  var body = drawer.querySelector('[data-cart-body]');
  var html = document.documentElement;
  var lastFocus = null;
  var hideTimer = null;
  var busy = Promise.resolve();

  // Out of any sticky/transformed ancestor
  document.body.appendChild(drawer);

  /* ---------- Open / close ---------- */
  function isOpen() { return drawer.classList.contains('is-open'); }

  function open() {
    if (isOpen()) return;
    clearTimeout(hideTimer);
    lastFocus = document.activeElement && document.activeElement !== document.body ? document.activeElement : null;
    drawer.removeAttribute('inert');
    // next frame so the slide-in transition runs from the closed state
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    html.classList.add('sg-cart-lock');
    setTimeout(function () {
      var close = drawer.querySelector('.sg-cd__close');
      (close || panel).focus({ preventScroll: true });
    }, 80);
  }

  function close() {
    if (!isOpen()) return;
    drawer.classList.remove('is-open');
    html.classList.remove('sg-cart-lock');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () { drawer.setAttribute('inert', ''); }, 400);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) close();
  });

  // Keep Tab inside the drawer
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-sg-cart-open]');
    if (!opener) return;
    e.preventDefault();
    open();
    refresh();
  });

  /* ---------- Rendering ---------- */
  function swap(markup) {
    if (!markup) return;
    var doc = new DOMParser().parseFromString(markup, 'text/html');
    var fresh = doc.querySelector('[data-cart-contents]');
    if (!fresh) return;
    // Keep focus on the same control (by item key) across the re-render
    var active = document.activeElement;
    var activeItem = active && active.closest && active.closest('[data-cart-item]');
    var activeKey = activeItem && activeItem.getAttribute('data-key');
    var activeRole = active && (active.hasAttribute('data-cart-qty') ? '[data-cart-qty]' :
      active.hasAttribute('data-cart-step') ? '[data-cart-step="' + active.getAttribute('data-cart-step') + '"]' : null);

    var current = body.querySelector('[data-cart-contents]');
    if (current) current.replaceWith(fresh); else body.appendChild(fresh);
    updateCount(parseInt(fresh.getAttribute('data-cart-count'), 10) || 0);

    if (isOpen()) {
      var target = activeKey && activeRole && body.querySelector('[data-cart-item][data-key="' + CSS.escape(activeKey) + '"] ' + activeRole);
      (target || (active && body.contains(active) ? active : body.querySelector('.sg-cd__close'))).focus({ preventScroll: true });
    }
  }

  function updateCount(count) {
    document.querySelectorAll('.bigcounter, [data-sg-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (el.hasAttribute('data-sg-cart-count')) el.hidden = !(count > 0);
    });
    document.querySelectorAll('[data-sg-cart-label]').forEach(function (el) {
      el.setAttribute('aria-label', 'Cart, ' + count + ' ' + (count === 1 ? 'item' : 'items'));
    });
  }

  function refresh() {
    busy = busy.then(function () {
      return fetch(root + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : {}; })
        .then(function (data) { swap(data[SECTION]); })
        .catch(function () {});
    });
    return busy;
  }

  /* ---------- Line changes ---------- */
  function setLoading(item, on) {
    if (item) item.classList.toggle('is-loading', on);
    drawer.classList.toggle('is-busy', on);
  }

  function showError(item, message) {
    var box = item && item.querySelector('[data-cart-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
  }

  function change(item, quantity) {
    var key = item.getAttribute('data-key');
    setLoading(item, true);
    if (quantity === 0) item.classList.add('is-removing');
    busy = busy.then(function () {
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: SECTION, sections_url: window.location.pathname })
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (data) { return { ok: r.ok, data: data }; });
        })
        .then(function (res) {
          if (!res.ok) {
            item.classList.remove('is-removing');
            setLoading(item, false);
            // e.g. "You can only add 3 of this item to your cart"
            showError(item, res.data.description || res.data.message || 'Sorry, that couldn’t be updated.');
            return refreshKeepError(item, res.data.description || res.data.message);
          }
          swap(res.data.sections && res.data.sections[SECTION]);
          drawer.classList.remove('is-busy');
          document.dispatchEvent(new CustomEvent('sg:cart:updated', { detail: res.data }));
        })
        .catch(function () {
          item.classList.remove('is-removing');
          setLoading(item, false);
          showError(item, 'Sorry, that couldn’t be updated. Please try again.');
        });
    });
    return busy;
  }

  // Re-render (to restore the real quantity) but keep the error message visible
  function refreshKeepError(item, message) {
    var key = item.getAttribute('data-key');
    return fetch(root + '?sections=' + SECTION)
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (data) {
        swap(data[SECTION]);
        var fresh = body.querySelector('[data-cart-item][data-key="' + CSS.escape(key) + '"]');
        if (fresh && message) showError(fresh, message);
      })
      .catch(function () {});
  }

  // One debounce timer per line, so quick taps on another line don't cancel this one
  var typeTimers = {};
  body.addEventListener('click', function (e) {
    var item = e.target.closest('[data-cart-item]');
    if (!item) return;
    var step = e.target.closest('[data-cart-step]');
    var input = item.querySelector('[data-cart-qty]');
    if (step && input) {
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-cart-step'), 10));
      input.value = next;
      var key = item.getAttribute('data-key');
      clearTimeout(typeTimers[key]);
      // short pause so several quick taps become one request
      typeTimers[key] = setTimeout(function () { delete typeTimers[key]; change(item, next); }, 250);
    }
    if (e.target.closest('[data-cart-remove]')) change(item, 0);
  });

  body.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var item = input.closest('[data-cart-item]');
    var value = Math.max(0, parseInt(input.value, 10) || 0);
    clearTimeout(typeTimers[item.getAttribute('data-key')]);
    change(item, value);
  });

  body.addEventListener('keydown', function (e) {
    // Enter in the quantity box applies it without submitting anything
    if (e.key === 'Enter' && e.target.matches('[data-cart-qty]')) {
      e.preventDefault();
      e.target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ---------- Add-to-cart integrations ---------- */
  function addedToCart() {
    return refresh().then(open);
  }

  document.addEventListener('sg:cart:added', addedToCart);

  // Legacy theme (assets/cart.api.js): replace the "added to cart" popup
  // with the drawer, and keep the drawer in sync with its cart updates.
  function hookLegacy() {
    if (!window.Shopify) return;
    Shopify.cartPopap = function () { addedToCart(); };
    Shopify.cartPopapForm = function () { addedToCart(); };
    // Add-to-cart errors (e.g. more than the stock allows): show the message
    // in the SG toast and refresh the drawer instead of the legacy modal
    var onError = Shopify.onError;
    Shopify.onError = function (xhr) {
      var message = '';
      try {
        var data = JSON.parse(xhr.responseText);
        message = data.description || data.message || '';
      } catch (e) {}
      if (window.SG && SG.toast) {
        SG.toast(message || 'Sorry, that couldn\u2019t be added to your cart.', true);
        refresh();
      } else if (typeof onError === 'function') {
        onError.apply(this, arguments);
      }
    };
    var onCartUpdate = Shopify.onCartUpdate;
    Shopify.onCartUpdate = function (cart) {
      if (typeof onCartUpdate === 'function') onCartUpdate.apply(this, arguments);
      if (cart && typeof cart.item_count === 'number') updateCount(cart.item_count);
      if (!isOpen()) refresh();
    };
  }
  hookLegacy();

  // Globo filter cards (collection + search pages) post a plain form to
  // /cart/add, which leaves the page for /cart. Add in the background
  // instead and show the drawer; any failure falls back to the real submit.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form.spf-product__form[action*="/cart/add"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) {
          if (window.SG && SG.toast) SG.toast(res.data.description || res.data.message || 'Sorry, that couldn\u2019t be added to your cart.', true);
          return;
        }
        return addedToCart();
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) btn.disabled = false; });
  }, true);

  window.SGCart = { open: open, close: close, refresh: refresh };
})();
